// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ViUd","top":"styles_top__1TwcB"};